document.addEventListener('DOMContentLoaded', function () {

  function updateImage(swatch) {
    const newImage = swatch.getAttribute('data-variant-image');
    if (!newImage) return;

    const card = swatch.closest('.card-wrapper');
    if (!card) return;

    const imgs = card.querySelectorAll('.card__media img');
    if (!imgs.length) return;

    imgs.forEach(img => {
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.src;
        img.dataset.originalSrcset = img.srcset;
      }
      img.src = newImage;
      img.srcset = newImage;
    });
  }

  function resetImage(card) {
    const imgs = card.querySelectorAll('.card__media img');
    if (!imgs.length) return;

    imgs.forEach(img => {
      if (img.dataset.originalSrc) {
        img.src = img.dataset.originalSrc;
        img.srcset = img.dataset.originalSrcset;
      }
    });
  }

  if (window.innerWidth > 768) {
    document.addEventListener('mouseover', function (e) {
      const swatch = e.target.closest('.color-swatch');
      if (!swatch) return;
      updateImage(swatch);
    });

    document.addEventListener('mouseout', function (e) {
      const swatch = e.target.closest('.color-swatch');
      if (!swatch) return;
      if (swatch.contains(e.relatedTarget)) return;
      resetImage(swatch.closest('.card-wrapper'));
    });
  }

  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.color-swatch');
    if (!swatch || window.innerWidth > 768) return;

    e.preventDefault();

    const card = swatch.closest('.card-wrapper');
    if (!card) return;

    const isActive = swatch.classList.contains('active');

    card.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));

    if (isActive) {
      resetImage(card);
    } else {
      swatch.classList.add('active');
      updateImage(swatch);
    }
  });
  
  function checkAllSelected(container) {
    const fieldsets = container.querySelectorAll("fieldset");
    return [...fieldsets].every(fieldset =>
      fieldset.querySelector('input[type="radio"]:checked')
    );
  }
  const variantRadios = document.querySelector("variant-radios");
  if (variantRadios && checkAllSelected(variantRadios)) {
    const submitBtn = document.querySelector(".product-form__buttons .product-form__submit");
    submitBtn.removeAttribute("disabled");
  }

});